import { createApi } from "@reduxjs/toolkit/query/react";
import {
  AddWaitlistBody,
  DeallocateRequest,
  LoadRegistrationExpandBody,
  LoadRegistrationExpandResult,
  FrontendRegistration,
  RemoveWaitlistBody,
  SaveStudentsResult,
  StudentSwapRequest,
} from "@timeedit/registration-schemas";
import { baseQuery } from "../../baseQuery";

export const registrationApiSlice = createApi({
  reducerPath: "registrationApi",
  baseQuery,
  tagTypes: ["Registration", "Expand"],
  endpoints(builder) {
    return {
      swap: builder.mutation<SaveStudentsResult, StudentSwapRequest>({
        query(body) {
          return {
            url: "/swap-members",
            method: "POST",
            body,
            header: {
              "Content-type": "application/json; charset=UTF-8",
            },
          };
        },
        invalidatesTags: ["Registration"],
      }),
      deallocate: builder.mutation<void, DeallocateRequest>({
        query(body) {
          return {
            url: "/remove-members",
            method: "POST",
            body,
            header: {
              "Content-type": "application/json; charset=UTF-8",
            },
          };
        },
        invalidatesTags: ["Registration"],
      }),
      joinWaitlist: builder.mutation<void, AddWaitlistBody>({
        query(body) {
          return {
            url: `/add-waitlist`,
            method: "POST",
            body,
            header: {
              "Content-type": "application/json; charset=UTF-8",
            },
          };
        },
        invalidatesTags: ["Registration"],
      }),
      leaveWaitlist: builder.mutation<boolean, RemoveWaitlistBody>({
        query(body) {
          return {
            url: `/remove-waitlist`,
            method: "POST",
            body,
            header: {
              "Content-type": "application/json; charset=UTF-8",
            },
          };
        },
        invalidatesTags: ["Registration"],
      }),
      fetchRegistration: builder.query<FrontendRegistration, void>({
        query() {
          return {
            url: "/registration",
            method: "GET",
          };
        },
        extraOptions: {
          validation: FrontendRegistration,
        },
        providesTags: ["Registration"],
      }),
      fetchExpand: builder.query<
        LoadRegistrationExpandResult,
        LoadRegistrationExpandBody
      >({
        query(body: LoadRegistrationExpandBody) {
          return {
            url: `/registration-expand`,
            method: "POST",
            body,
          };
        },
        extraOptions: {
          validation: LoadRegistrationExpandResult,
        },
        providesTags: ["Expand"],
      }),
    };
  },
});

export const {
  useSwapMutation,
  useDeallocateMutation,
  useFetchRegistrationQuery,
  useLazyFetchRegistrationQuery,
  useLazyFetchExpandQuery,
  useJoinWaitlistMutation,
  useLeaveWaitlistMutation,
} = registrationApiSlice;
